import React from 'react';
import DownloadSection from '../components/DownloadSection';
import ContactUsSection from '../components/ContactUsSection';


const KontakKami = () => {
    return (
        <div>
            <ContactUsSection />
            <DownloadSection />
            {/* Other sections of Beranda can be added here */}
        </div>
    );
};

export default KontakKami;